import { Button } from '@mantine/core'
import TablePaginaitonTemplate from '@v2/commons/templates/TablePaginationTemplate/TablePaginationTemplate.template'
import useGetOrganizationRoles from '@v2/domains/role/hooks/useOrganizationRoles'

import { Icons } from 'src/common/components'
import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import { TBreadCrumbItems } from 'src/v2/commons/components/Breadcrumb'

import UsersTable from '../components/UsersTable/UsersTable.component'
import UsersTableFilter from '../components/UsersTableFilter/UsersTableFilter.component'
import { useUsers } from '../hooks/useUsers.hook'

const breadCrumbItems: TBreadCrumbItems = [
  { title: 'Home' },
  { title: 'Administration Panel' },
  { title: 'Users' },
]
const Filters = withErrorBoundaryAndPolicyCheck(
  UsersTableFilter,
  'is_enable_users_filters',
  true,
)

const Table = withErrorBoundaryAndPolicyCheck(
  UsersTable,
  'is_enable_users_table',
  true,
)

const UsersAdministrationPage = () => {
  const {
    users,
    isLoading,
    handlePaginate,
    handleOrderBy,
    filterOrderBy,
    handleEditUser,
    handleCreateUser,
    paginationLimitField,
    tablePage,
    isFetching,
    isError,
    usersFiltersForm,
    isProgrammaticFormUpdateRef,
    setFiltersOpen,
    filtersOpen,
  } = useUsers()

  const { data: organizationRoles } = useGetOrganizationRoles()

  return (
    <TablePaginaitonTemplate
      isLoading={isLoading}
      isFetching={isFetching}
      isError={isError}
      isRecords={!!users?.records.length}
      handlePaginate={handlePaginate}
      paginationLimitField={paginationLimitField}
      currentPage={tablePage}
      totalRecords={users?.totalRecords || 0}
      title="Users"
      emptyPageTerm="User"
      header={
        <Button
          variant="filled"
          leftSection={<Icons.Plus />}
          onClick={handleCreateUser}
        >
          Create New User
        </Button>
      }
      breadCrumbItems={breadCrumbItems}
      loadingSkeletonProps={{ height: 30 }}
      filters={
        <Filters
          organizationRoles={organizationRoles}
          isProgrammaticFormUpdateRef={isProgrammaticFormUpdateRef}
          totalRecords={users?.totalRecords || 0}
          usersFiltersForm={usersFiltersForm}
          setFiltersOpen={setFiltersOpen}
          filtersOpen={filtersOpen}
        />
      }
    >
      <Table
        handleEditUser={handleEditUser}
        users={users}
        handleOrderBy={handleOrderBy}
        filterOrderBy={filterOrderBy}
      />
    </TablePaginaitonTemplate>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  UsersAdministrationPage,
  'is_get_roles_enabled',
  true,
)
